 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    // Productos recomendados del carrito lateral. Antes se descargaba la página completa en cada cambio del
    // carrito (y en cada cambio de la propia lista), lo que trababa el carrito en celular. Ahora:
    //  - solo trabaja si hay productos recomendados configurados,
    //  - pide solo la sección del carrito (no la página completa),
    //  - y solo cuando cambian los renglones del carrito, no por sus propios cambios.
    function tieneRecomendados(scope) {
      return !!(scope || document).querySelector('#cart-drawer-upsell-wrapper li')
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element || !tieneRecomendados()) return

      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'
      let timer
      let actualizando = false

      const observer = new MutationObserver((mutations) => {
        if (actualizando) return
        const cambioRenglones = mutations.some((m) => m.target.closest && m.target.closest('cart-drawer-items') && !m.target.closest('#cart-drawer-upsell'))
        if (!cambioRenglones) return
        clearTimeout(timer)
        timer = setTimeout(async () => {
          actualizando = true
          try {
            const respuesta = await fetch(root + '?section_id=cart-drawer')
            const nuevo = new DOMParser().parseFromString(await respuesta.text(), 'text/html').querySelector('#cart-drawer-upsell-wrapper')
            const actual = document.querySelector('#cart-drawer-upsell-wrapper')
            if (nuevo && actual) actual.replaceWith(nuevo)
            const lista = document.querySelector('#CartDrawer #cart-drawer-upsell')
            if (lista) lista.remove()
            const envoltura = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
            if (envoltura && nuevo) envoltura.insertAdjacentHTML('beforeend', nuevo.innerHTML)
            else insertSectionCartDrawer()
            if (!document.querySelector('.cart-drawer-upsell-list li')) {
              const vacia = document.querySelector('#cart-drawer-upsell')
              if (vacia) vacia.remove()
            }
          } catch (e) {}
          setTimeout(() => { actualizando = false }, 50)
        }, 300)
      })

      observer.observe(element, { childList: true, subtree: true })
    }
    listenCartDrawer()
  })();